var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCard',[_c('VCardText',[_c('VOpeningHour',{ref:"form",attrs:{"title":_vm.$t('venue.deliveryHours'),"initial-values":_vm.initialValues}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }